// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2ZC2q","messages":"Chat_messages__bVI1t","dateDivider":"Chat_dateDivider__1HZxZ"};